export default {
  title: 'Producten',
  buttons: {
    add_product: 'Product toevoegen',
  },
  modals: {
    delete_product: {
      title: 'Weet u het zeker',
      description:
        'Alle huidige abonnementen met dit product blijven actief, maar er kunnen geen nieuwe abonnementen mee worden aangemaakt. Deze actie kan niet ongedaan worden gemaakt!',
    },
    delete_price: {
      title: 'Weet u het zeker',
      description:
        'Alle huidige abonnementen met deze prijs blijven actief, maar er kunnen geen nieuwe abonnementen mee worden aangemaakt. Deze actie kan niet ongedaan worden gemaakt!',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_delete_product: 'Product verwijderen mislukt',
    product_got_deleted: 'Product verwijderd',
    failed_to_delete_price: 'Prijs verwijderen mislukt',
    price_got_deleted: 'Prijs verwijderd',
  },
};
